import { render } from "./AddReceiverMail.vue?vue&type=template&id=452b82aa"
import script from "./AddReceiverMail.vue?vue&type=script&lang=js"
export * from "./AddReceiverMail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__